const TimeReportSummaryItemsType = [
    {
        name: "PROFESSIONALS",
        value: 1
    },
    {
        name: "HELPERS",
        value: 2
    },
    {
        name: "MATERIALS",
        value: 3
    },
    {
        name: "DRIVE",
        value: 4
    },
]

export default TimeReportSummaryItemsType;